import Link from 'components/link/Link'
import { Button } from '@boltenergy-be/design-system'
import { checkIsLink } from 'features/dynamic-tariff/components/quiz-action-button/utils'
import { QuizActionButtonProps } from 'features/dynamic-tariff/components/quiz/types'
import { memo, PropsWithChildren } from 'react'
import { useGetLanguage } from 'hooks/useGetLanguage'

const QuizActionButton = memo(({ actionCard, variant, className, children }: PropsWithChildren<QuizActionButtonProps>) => {
  // i18n
  const language = useGetLanguage()

  return (
    <>
      {checkIsLink(actionCard) ? (
        <Link
          representation="button"
          href={actionCard.externalUrl ? actionCard.externalUrl(language) : actionCard.internalRoute}
          external={!!actionCard.externalUrl?.(language)}
          {...{ variant, className }}
        >
          {children}
        </Link>
      ) : (
        <Button onClick={actionCard.action} {...{ variant, className }}>
          {children}
        </Button>
      )}
    </>
  )
})

QuizActionButton.displayName = 'QuizActionButton'

export default QuizActionButton
